@if (selectedTabDv === 4 && (werknemerEntity$ | async)) {
  <form [formGroup]="lijstFg">
    <div formArrayName="fiscaleGegevens">
      @for (item of fiscaleGegevens.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="details-row">
            <div class="d-flex flex-wrap align-items-end gap-2">

              <div class="d-flex gap-2 align-items-end">
                <snelstart-ui-date-form-control
                  [disabledControl]="true"
                  [formControl]="item.controls.periode.controls.begindatum"
                  [label]="0 === (i) ? 'Ingangsdatum' : ''"
                  class="custom-input-150"
                  id="begindatum4">
                </snelstart-ui-date-form-control>

                <snelstart-ui-date-form-control
                  [disabledControl]="!!fiscaleGegevens.at(i).getRawValue().periode.einddatum"
                  [formControl]="item.controls.periode.controls.einddatum"
                  [label]="0 === (i) ? 'Einddatum' : ''"
                  class="custom-input-150"
                  id="einddatum4">
                </snelstart-ui-date-form-control>
              </div>

              <snelstart-ui-select-form-control
                [disabledControl]="!!fiscaleGegevens.at(i).getRawValue().periode.einddatum"
                [formControl]="item.controls.loonheffingskorting"
                [label]="0 === (i) ? 'Loonheffingskorting' : ''"
                [options]="optionsJaNee"
                class="custom-input-150"
                id="loonheffingskorting">
              </snelstart-ui-select-form-control>

              <snelstart-ui-number-form-control
                [disabledControl]="!!fiscaleGegevens.at(i).getRawValue().periode.einddatum"
                [formControl]="item.controls.jaarloonBijzonderTarief"
                [label]="0 === (i) ? 'Jaarloon bijzonder tarief' : ''"
                [prefix]="'€'"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                id="jaarloonBijzonderTarief">
              </snelstart-ui-number-form-control>

              @if (i > 0 && !fiscaleGegevens.at(i).getRawValue().periode.einddatum) {
                <div class="btn-align-up-icon">
                  <snelstart-ui-button
                    (click)="verwijderRijFiscaal(i)"
                    icon="trash"
                    id="delete"
                    size="medium"
                    type="secondary">
                  </snelstart-ui-button>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>

    @if (checkEinddatum()) {
      <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                           id="add"
                           type="link">Nieuwe periode toevoegen
      </snelstart-ui-button>
    }
  </form>
}
